module.exports = __webpack_public_path__ + "img/background-for-email.f18d867b.jpg";